<template>
  <div>
    <TitleBar>
      <template v-slot:title><translate>Pending Invitations</translate></template>
      <template v-slot:buttons>
        <GekkoButton
          v-if="!isGekkoAccountant"
          @click="inviteCustomer()"
          :text="$gettext('Invite Customer')"
          icon="fa fa-plus"
          class="mr-2"
        />
        <GekkoButton
          v-if="isGekkoAccountant"
          @click="connectGekkoAccountant()"
          :text="$gettext('Connect Gekko Accountant')"
          icon="fa fa-gear"
          class="ml-2"
          variant="danger"
        />
      </template>
    </TitleBar>
    <div class="content">
      <InviteCustomerModal ref="invite_customer_modal" @invite-sent="onInviteSent" />
      <InvitationsList ref="invitations_list" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GekkoButton from '@/components/GekkoButton'
import TitleBar from '@/components/TitleBar'
import InvitationsList from '@/components/accountants/InvitationsList.vue'
import InviteCustomerModal from '@/components/accountants/InviteCustomerModal.vue'

export default {
  name: 'PendingInvitations',
  components: {
    GekkoButton,
    TitleBar,
    InvitationsList,
    InviteCustomerModal
  },
  computed: {
    ...mapGetters({
      currentCompany: 'main/getCurrentCompany',
    }),
    isGekkoAccountant() {
      if (this.currentCompany.accountant_branding) return this.currentCompany.accountant_branding.is_gekko_accountant
      else return false
    },
  },
  methods: {
    inviteCustomer() {
      this.$refs.invite_customer_modal.showInviteCustomerModal = true
    },
    connectGekkoAccountant() {
      this.$refs.gekko_accountant_modal.showGekkoAccountantModal = true
    },
    onInviteSent () {
      this.$refs.invitations_list.getPendingInvites(null)
    }
  },
}
</script>